import { createActions, createReducer } from 'reduxsauce'

const listaPagos = [
    { value: '', label: 'Todas' },
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
]

/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    setExercicioConsultaOrdemCronologicaPagamentoMP: ['exercicio'],
    setAdministracaoConsultaOrdemCronologicaPagamentoMP: ['administracao'],
    setSituacaoConsultaOrdemCronologicaPagamentoMP: ['situacao'],
    setPagosConsultaOrdemCronologicaPagamentoMP: ['pagos'],
    setNomeCredorConsultaOrdemCronologicaPagamentoMP: ['nomeCredor'],
    setCnpjConsultaOrdemCronologicaPagamentoMP: ['cnpj'],
    setCpfConsultaOrdemCronologicaPagamentoMP: ['cpf'],
    setDataVencimentoInicialConsultaOrdemCronologicaPagamentoMP: ['dataVencimentoInicial'],
    setDataVencimentoFinalConsultaOrdemCronologicaPagamentoMP: ['dataVencimentoFinal'],
    setDataPagamentoInicialConsultaOrdemCronologicaPagamentoMP: ['dataPagamentoInicial'],
    setDataPagamentoFinalConsultaOrdemCronologicaPagamentoMP: ['dataPagamentoFinal'],
    setDataDocumentoInicialConsultaOrdemCronologicaPagamentoMP: ['dataDocumentoInicial'],
    setDataDocumentoFinalConsultaOrdemCronologicaPagamentoMP: ['dataDocumentoFinal'],
    setValorLiquidacaoInicialConsultaOrdemCronologicaPagamentoMP: ['valorLiquidacaoInicial'],
    setValorLiquidacaoFinalConsultaOrdemCronologicaPagamentoMP: ['valorLiquidacaoFinal'],
    setDocumentoConsultaOrdemCronologicaPagamentoMP: ['documento'],
    setSerieDocumentoConsultaOrdemCronologicaPagamentoMP: ['serieDocumento'],
    setRecursoConsultaOrdemCronologicaPagamentoMP: ['recurso'],
    setDestinacaoConsultaOrdemCronologicaPagamentoMP: ['destinacao'],
    setNumeroContratoConsultaOrdemCronologicaPagamentoMP: ['numeroContrato'],
    setObjetoContratoConsultaOrdemCronologicaPagamentoMP: ['objetoContrato'],
    limpaFiltroConsultaOrdemCronologicaPagamentoMP: [],
    receberFiltroConsultaOrdemCronologicaPagamentoMP: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: new Date().getFullYear(),
    administracao: [],
    situacao: [],
    pagos: { value: listaPagos[0].value, label: listaPagos[0].label },
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    dataPagamentoInicial: '',
    dataPagamentoFinal: '',
    dataDocumentoInicial: '',
    dataDocumentoFinal: '',
    valorLiquidacaoInicial: '',
    valorLiquidacaoFinal: '',
    documento: '',
    serieDocumento: '',
    recurso: [],
    destinacao: [],
    numeroContrato: '',
    objetoContrato: '',
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: action.situacao }
}

const setPagos = (state = INITIAL_STATE, action) => {
    return { ...state, pagos: action.pagos }
}
const setNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: action.nomeCredor }
}
const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}
const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}
const setDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: action.dataVencimentoInicial }
}
const setDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: action.dataVencimentoFinal }
}
const setDataPagamentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoInicial: action.dataPagamentoInicial }
}
const setDataPagamentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoFinal: action.dataPagamentoFinal }
}
const setDataDocumentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataDocumentoInicial: action.dataDocumentoInicial }
}
const setDataDocumentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataDocumentoFinal: action.dataDocumentoFinal }
}
const setValorLiquidacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, valorLiquidacaoInicial: action.valorLiquidacaoInicial }
}
const setValorLiquidacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, valorLiquidacaoFinal: action.valorLiquidacaoFinal }
}
const setDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: action.documento }
}
const setSerieDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, serieDocumento: action.serieDocumento }
}
const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}
const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}
const setNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: action.numeroContrato }
}
const setObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: action.objetoContrato }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setAdministracao,
    [Types.SET_SITUACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setSituacao,
    [Types.SET_PAGOS_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setPagos,
    [Types.SET_NOME_CREDOR_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setNomeCredor,
    [Types.SET_CNPJ_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setCnpj,
    [Types.SET_CPF_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setCpf,
    [Types.SET_DATA_VENCIMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setDataVencimentoInicial,
    [Types.SET_DATA_VENCIMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setDataVencimentoFinal,
    [Types.SET_DATA_PAGAMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setDataPagamentoInicial,
    [Types.SET_DATA_PAGAMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setDataPagamentoFinal,
    [Types.SET_DATA_DOCUMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setDataDocumentoInicial,
    [Types.SET_DATA_DOCUMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setDataDocumentoFinal,
    [Types.SET_VALOR_LIQUIDACAO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setValorLiquidacaoInicial,
    [Types.SET_VALOR_LIQUIDACAO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setValorLiquidacaoFinal,
    [Types.SET_DOCUMENTO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setDocumento,
    [Types.SET_SERIE_DOCUMENTO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setSerieDocumento,
    [Types.SET_RECURSO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setDestinacao,
    [Types.SET_NUMERO_CONTRATO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setNumeroContrato,
    [Types.SET_OBJETO_CONTRATO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setObjetoContrato,
    [Types.LIMPA_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: receberFiltro,
})
